import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { User, Lock, ArrowRight, Car } from 'lucide-react';
import '../../Styles/Admin.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  if (user) {
    return <Navigate to="/admin" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const result = await login(username, password);

    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.message);
    }
    
    setIsLoading(false);
  };

  return (
    <div className="login-container" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#000000',
      padding: '2rem',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative Background Elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '10%',
        width: '300px',
        height: '300px',
        background: 'rgba(0, 209, 255, 0.05)',
        filter: 'blur(100px)',
        borderRadius: '50%'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '10%',
        right: '10%',
        width: '400px',
        height: '400px',
        background: 'rgba(0, 209, 255, 0.03)',
        filter: 'blur(120px)',
        borderRadius: '50%'
      }}></div>

      <div className="login-card" style={{
        width: '100%',
        maxWidth: '420px',
        background: 'rgba(10, 10, 10, 0.8)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(0, 209, 255, 0.1)',
        borderRadius: '2rem',
        padding: '3rem',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.9), 0 0 40px rgba(0, 209, 255, 0.05)',
        position: 'relative',
        zIndex: 1
      }}>
        <div className="login-header" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <div style={{
            width: '70px',
            height: '70px',
            background: 'linear-gradient(135deg, #00d1ff 0%, #0072ff 100%)',
            borderRadius: '1.25rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1.5rem',
            boxShadow: '0 0 30px rgba(0, 209, 255, 0.3)',
            transform: 'rotate(-5deg)'
          }}>
            <Car size={36} color="white" />
          </div>
          <h2 style={{ 
            fontSize: '2rem', 
            fontWeight: '900', 
            color: 'white', 
            letterSpacing: '-0.05em',
            textTransform: 'uppercase'
          }}>
            ERENİS <span style={{ color: '#00d1ff', textShadow: '0 0 15px rgba(0, 209, 255, 0.5)' }}>ADMIN</span>
          </h2>
          <p style={{ color: '#64748b', fontSize: '0.9rem', marginTop: '0.75rem', fontWeight: '500' }}>Sistem Kontrol Paneli</p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div className="form-group" style={{ position: 'relative' }}>
            <User size={18} style={{ position: 'absolute', left: '1.25rem', top: '50%', transform: 'translateY(-50%)', color: '#334155' }} />
            <input
              type="text"
              placeholder="Kullanıcı Adı veya E-posta"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{
                width: '100%',
                background: '#0a0a0a',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                padding: '1rem 1rem 1rem 3.25rem',
                borderRadius: '1rem',
                color: 'white',
                outline: 'none',
                transition: 'all 0.3s',
                fontSize: '1rem',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.5)'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#00d1ff';
                e.target.style.boxShadow = '0 0 10px rgba(0, 209, 255, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.05)';
                e.target.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.5)';
              }}
            />
          </div>

          <div className="form-group" style={{ position: 'relative' }}>
            <Lock size={18} style={{ position: 'absolute', left: '1.25rem', top: '50%', transform: 'translateY(-50%)', color: '#334155' }} />
            <input
              type="password"
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                background: '#0a0a0a',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                padding: '1rem 1rem 1rem 3.25rem',
                borderRadius: '1rem',
                color: 'white',
                outline: 'none',
                transition: 'all 0.3s',
                fontSize: '1rem',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.5)'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#00d1ff';
                e.target.style.boxShadow = '0 0 10px rgba(0, 209, 255, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.05)';
                e.target.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.5)';
              }}
            />
          </div>

          {error && (
            <div style={{
              background: 'rgba(239, 68, 68, 0.05)',
              border: '1px solid rgba(239, 68, 68, 0.2)',
              color: '#f87171',
              padding: '1rem',
              borderRadius: '0.75rem',
              fontSize: '0.85rem',
              textAlign: 'center',
              fontWeight: '500'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            style={{
              marginTop: '1rem',
              background: 'linear-gradient(90deg, #00d1ff, #0072ff)',
              color: 'white',
              padding: '1.125rem',
              borderRadius: '1rem',
              fontWeight: '700',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              transition: 'all 0.4s',
              opacity: isLoading ? 0.7 : 1,
              boxShadow: '0 10px 20px -5px rgba(0, 209, 255, 0.4)',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}
            onMouseOver={(e) => {
              if(!isLoading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 15px 25px -5px rgba(0, 209, 255, 0.5)';
              }
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 10px 20px -5px rgba(0, 209, 255, 0.4)';
            }}
          >
            {isLoading ? 'Doğrulanıyor...' : 'Sisteme Gir'}
            {!isLoading && <ArrowRight size={20} />}
          </button>
        </form>

        <div style={{ marginTop: '3rem', textAlign: 'center' }}>
          <p style={{ color: '#334155', fontSize: '0.75rem', fontWeight: '600', letterSpacing: '0.1em' }}>
            &copy; 2026 ERENİS OTOMOTİV • PRESTIGE & POWER
          </p>
        </div>
      </div>
    </div>
  );
};


export default Login;

